import { render } from "./searchResult.vue?vue&type=template&id=24e85a87&scoped=true"
import script from "./searchResult.vue?vue&type=script&lang=js"
export * from "./searchResult.vue?vue&type=script&lang=js"

import "./searchResult.vue?vue&type=style&index=0&id=24e85a87&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-24e85a87"

export default script